import { getterTree, mutationTree, actionTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'

export const state = () => ({
  reviews: {} as { [key: string]: any },
  currentId: '',
  isLoading: false
})

export const getters = getterTree(state, {
  review({ reviews, currentId }) {
    return reviews[currentId]
  },
  isLoading({ isLoading }) {
    return isLoading
  }
})

export const mutations = mutationTree(state, {
  addReview(state, { id, review }) {
    state.reviews[id] = review
  },
  removeReview(state, { id }) {
    delete state.reviews[id]
  },
  setState
})

export const actions = actionTree(
  { state, getters, mutations },
  {
    setCurrentReview({ dispatch }, scholarshipId) {
      return dispatch('fetchReview', scholarshipId)
    },
    fetchReview({ commit }, scholarshipId) {
      commit('setState', { stateName: 'isLoading', data: true })

      return this.$api.scholarship.applicationReview({ id: scholarshipId })
        .then((res: Axios.AxiosResponse) => {
          commit('addReview', { id: scholarshipId, review: res.data.data })
          // reset data for 'review' getter update
          commit('setState', { stateName: 'currentId', data: '' })
          commit('setState', { stateName: 'currentId', data: scholarshipId })
        })
        .finally(() => commit('setState', { stateName: 'isLoading', data: false }))
        .catch((err: Error) => this.$sentry.captureException(err))
    }
  }
)
